module.exports = __webpack_public_path__ + "static/media/card2.c0f39a54.png";